import { Link } from 'react-router-dom';
import { latestContent } from '@/mocks/siteData';

export default function LatestContent() {
  return (
    <section className="w-full max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8 py-16" aria-labelledby="latest-title">
      <div className="flex items-end justify-between mb-10">
        <div>
          <h2 id="latest-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            最新上线
          </h2>
          <p className="text-sm text-foreground-500 mt-2">刚刚更新的精彩内容，别错过</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {latestContent.map((item) => (
          <Link
            key={item.id}
            to={`/article/${item.id}`}
            className="group flex gap-4 bg-white rounded-xl border border-background-200 p-4 hover:border-background-300 transition-all duration-300 cursor-pointer"
          >
            <div className="relative w-28 h-20 md:w-36 md:h-24 flex-shrink-0 rounded-lg overflow-hidden">
              <img
                src={item.imageUrl}
                alt={item.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute bottom-1.5 right-1.5 px-1.5 py-0.5 rounded bg-black/70 text-white text-[10px] font-medium">
                {item.duration}
              </span>
            </div>
            <div className="flex-1 min-w-0 flex flex-col justify-between">
              <div>
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors mb-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1">{item.excerpt}</p>
              </div>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="px-2 py-0.5 rounded-full bg-background-100 text-foreground-500">{item.category}</span>
                <span>{item.date}</span>
                <span className="flex items-center gap-0.5"><i className="ri-eye-line"></i> {(item.views / 10000).toFixed(1)}万</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}